<template>
  <div class="submit-face bg-page">
    <div style="background-color: #fff; padding: 0 24px 20px; color: #323c4b">
      <div class="text-14 leading-24 font-500 mt-20">
        为满足项目通行需求，需要采集您的信息以核实身份！
      </div>

      <div class="mt-5 text-16 text-center text-default font-500">当前人员: {{ currentName }}</div>

      <div class="mt-20 text-14 leading-24">可通过以下方式提交信息：</div>

      <div>
        <van-uploader class="w-full" accept="image/*" :after-read="afterRead" capture="camera">
          <div class="image w-full flex flex-col justify-center items-center relative">
            <img class="icon" src="@/assets/visitor/camera.png" />
            <span>通过相机提交</span>
            <img class="bg bg1" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg2" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg3" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg4" src="@/assets/visitor/pic-bg.png" />
          </div>
        </van-uploader>
        <div class="tip">
          <p>1.正对屏幕不遮挡</p>
          <p>2.需授权相机权限</p>
          <p>3.保证光线充足</p>
        </div>
      </div>
      <div>
        <van-uploader class="w-full" accept="image/*" :after-read="afterRead">
          <div class="image w-full flex flex-col justify-center items-center relative">
            <img src="@/assets/visitor/pic.png" />
            <span>通过相册提交</span>
            <img class="bg bg1" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg2" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg3" src="@/assets/visitor/pic-bg.png" />
            <img class="bg bg4" src="@/assets/visitor/pic-bg.png" />
          </div>
        </van-uploader>
        <div class="tip">
          <p>1.JPG、JPEG 和 PNG 中任一种</p>
          <p>2.大于等于30K，小于等于400K</p>
          <p>3.像素不低于128*128px，不高于1024*1024px</p>
          <p>4.大小占整张照片 1/3 以上</p>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>注意事项：</div>
      <p>1.表情：中性或微笑，眼睛自然睁开，嘴唇自然闭合</p>
      <p>2.眼镜：眼镜框不应遮挡眼睛，镜片应无色无反光</p>
      <p>3.遮挡：遮挡物不应遮挡眉毛、眼睛、嘴巴、鼻子及脸部轮廓</p>
      <p>
        4.姿态：水平转动角应在±10°以内，俯仰角应在±10°以内，倾斜角应在±10°以内
      </p>
    </div>

    <Popup v-model:show="popupShow" title="确认提交" height="95%" :round="true">
      <div class="flex flex-col h-full">
        <div class="flex flex-1 justify-center items-center" style="padding:0 40px 80px">
          <img style="max-height:500px" class="w-full" :src="imageUrl" />
        </div>

        <FooterButton ok-text="提交" @cancel="handleCancel" @submit="handleSubmit" />
      </div>
    </Popup>
  </div>
</template>

<script setup>
import to from "await-to-js";
import { ref } from "vue";
import { Dialog } from "vant";
import { useRoute, useRouter } from "vue-router";
import { useCompressor, useBlobToBase64 } from "@/hooks/useCompressor.js";
import { vLoading } from "@/utils/loading";
import { repairService, userService, visitorService } from "@/service";
import Popup from "@/components/PopupPicker/Popup.vue";
import { FooterButton } from "@/components/FormView/index";

const route = useRoute();
const router = useRouter();

const imageUrl = ref("");
const currentName = route.query.name;
const submitType = route.query.type; //1:本人更新   2：同住人更新
const popupShow = ref(false);

const updateSelf = async () => {
  vLoading.start();
  const [error] = await to(userService.user_info_change({ face_pic: imageUrl.value }));
  vLoading.stop();
  if (error) return false;
  return true;
};

const updateOther = async () => {
  vLoading.start();
  const [error] = await to(
    visitorService.related_face_modify({
      face_pic: imageUrl.value,
      name: currentName,
      id: route.query.id
    })
  );
  vLoading.stop();
  if (error) return false;
  return true;
};

const handleSubmit = async () => {
  let result = null;
  if (submitType == "1") result = await updateSelf();
  if (submitType == "2") result = await updateOther();
  if (result) {
    Dialog.alert({
      title: "提示",
      message: "信息提交成功"
    }).then(() => {
      router.go(-1);
    });
  } else {
    Dialog.alert({
      title: "提示",
      message: "信息提交失败，请重新提交"
    }).then(() => {
      popupShow.value = false;
    });
  }
};

const handleCancel = () => {};

const afterRead = async file => {
  const files = [].concat(file);
  try {
    files.forEach(async file => {
      const form = new FormData();

      if (file.file.type.includes("image")) {
        const compressFiles = await new Promise(resolve => {
          useCompressor(file.content, {
            quality: 0.6,
            success: resolve
          });
        });
        const base64 = useBlobToBase64(compressFiles, file.file.name, file.file.type);
        form.append("my_files", base64);
      } else {
        form.append("my_files", file.file);
      }

      vLoading.start();
      const [error, { data }] = await to(repairService.saveImg(form));
      vLoading.stop();
      if (error) return;

      imageUrl.value = data.data[0].img_url;
      popupShow.value = true;
    });
  } catch {}
};
</script>

<style lang="less" scoped>
:deep(.van-uploader__input-wrapper) {
  width: 100%;
}
.submit-face {
  .image {
    margin-top: 16px;
    background-color: #fafcff;
    height: 160px;
    & > img {
      width: 80px;
      height: 80px;
    }
    & > span {
      margin-top: 10px;
      font-size: 12px;
      color: #626e81;
      line-height: 12px;
    }
    .bg {
      position: absolute;
      width: 25px;
      height: 25px;
    }
    .bg1 {
      transform: rotate(90deg);
      left: 0;
      top: 0;
    }
    .bg2 {
      transform: rotate(180deg);
      right: 0;
      top: 0;
    }
    .bg3 {
      left: 0;
      bottom: 0;
    }
    .bg4 {
      transform: rotate(270deg);
      right: 0;
      bottom: 0;
    }
  }
  .tip {
    font-size: 12px;
    color: #626e81;
    line-height: 18px;
    margin-top: 8px;
  }

  .footer {
    padding: 0 24px 30px;
    & > div {
      margin-top: 16px;
      font-size: 12px;
      color: #323c4b;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 6px;
    }
    & > p {
      font-size: 12px;
      color: #626e81;
      line-height: 18px;
    }
  }
}
</style>
